import { render, staticRenderFns } from "./MaxLikesCard.vue?vue&type=template&id=391c8af0&scoped=true"
import script from "./MaxLikesCard.vue?vue&type=script&lang=ts"
export * from "./MaxLikesCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxLikesCard.vue?vue&type=style&index=0&id=391c8af0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c8af0",
  null
  
)

export default component.exports